(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floorsupply-quote-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updateServices = (form) => {
      const floor = form.querySelector('[data-fs-quote-floor]');
      const service = form.querySelector('[data-fs-quote-service]');
      const installation = service?.querySelector('[data-installation]');
      const hint = form.querySelector('[data-fs-supply-hint]');
      if (!floor || !service || !installation || !hint) return;
      const supplyOnly = floor.selectedOptions[0]?.hasAttribute('data-no-installation') === true;
      installation.disabled = supplyOnly;
      installation.hidden = supplyOnly;
      if (supplyOnly && installation.selected) service.value = '';
      hint.hidden = !supplyOnly;
    };
    const initialize = (root) => root.querySelectorAll('.fs-quote__form').forEach(updateServices);
    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-fs-quote-floor]')) {
        const form = event.target.closest('.fs-quote__form');
        if (form) updateServices(form);
      }
    });
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    initialize(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
